import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from '@vwfs-bronson/bronson-react';

interface RegistrationCostModalProps {
  visible: boolean;
  onCancel?: any;
}

export const WarningModal: FunctionComponent<RegistrationCostModalProps> = (props) => {
  const { visible, onCancel } = props;
  const { t } = useTranslation();

  return (
    <Modal
      id="WarningModal"
      hideTitle
      buttonCancelText={t('warningModal:closeButton')}
      onCancel={() => onCancel()}
      onClose={() => onCancel()}
      shown={visible}
      asPortal
      stretch
      className="u-font-size-fs-2"
      title={t('warningModal:warningModalTitle')}
    >
      <h6> {t('warningModal:paragraph1')} </h6>
      <h6> {t('warningModal:paragraph2')} </h6>
      <br />
    </Modal>
  );
};
